import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { ToastService } from 'src/app/shared/services/angular-service/toast.service';
import { UserService } from 'src/app/shared/services/node-api/user.service';

@Component({
  selector: 'app-contact-us-form',
  templateUrl: './contact-us-form.component.html',
  styleUrls: ['./contact-us-form.component.scss'],
})
export class ContactUsFormComponent implements OnInit {
  contactusForm: UntypedFormGroup;
  token: any = undefined;

  constructor(
    public userService: UserService,
    public toastService: ToastService,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {
    this.contactusForm = new UntypedFormGroup({
      name: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(20),
      ]),
      email: new UntypedFormControl('', [Validators.required, Validators.email]),
      company_name: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(30),
      ]),
      query: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(100),
      ]),
    });
  }

  ngOnInit(): void {
    this.recaptchaV3Service
      .execute('suggestionRequest')
      .subscribe((token: string) => {
        this.token = token;
      });
  }

  submit() {
    this.userService.contactData(this.contactusForm.value, this.token).then(
      (data: any) => {
        this.toastService.addSingle(
          'success',
          'You have successfully send your query!',
          ''
        );
        this.contactusForm.reset();
        window.location.reload();
      },
      (err) => {
        this.toastService.addSingle('error', 'Error', err.error.message);
      }
    );
  }
}
